export const state = {
  income: [],
  approved: [],
  company: [],
  entreaties:[]
};
